import { toast } from "react-toastify";
import React, { Component } from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";

import BusinessUserForm from "components/businesses/tabs/business-users/BusinessUserForm";
import BusinessUsersApi from "apis/BusinessUsers";
import AuthApi from "apis/Auth";

import {
  setRole,
  setToken,
  setBusinessId,
  setUserId,
  setDashboardMetricObject,
  getUserInvitation,
  setContactDetails,
  setUserData,
  setConfirmed
} from "constants/localStorageManager";
import { ROUTES, insertIdtoUrl, TRIAL_SIGNUP_ROUTES } from "constants/Routes";
import logo from "assets/logo/soono_FF-02.png";

class AddNewBusinessUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      middle_name: "",
      last_name: "",
      email: "",
      role: "",
      password: "",
      password_confirmation: "",
      businessId: this.props.match.params.id,
      businessName: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.addUser = this.addUser.bind(this);
  }

  componentWillMount() {
    let { businessName } = getUserInvitation();
    this.setState({ businessName });
  }

  addUser() {
    var that = this;
    let { role, email, businessName } = getUserInvitation();
    this.setState({ email, role, businessName });
    if (role === "admin") {
      role = 0;
    } else {
      role = 1;
    }
    const {
      first_name,
      middle_name,
      last_name,
      password,
      password_confirmation
    } = this.state;

    BusinessUsersApi.addNew(
      first_name,
      middle_name,
      last_name,
      email,
      role,
      password,
      password_confirmation,
      this.props.match.params.id
    )
      .then(data => {
        AuthApi.login(email, password)
          .then((response) => {
            const token = response.headers.authorization;
            const { confirmed } = response.data;

            setToken(token);
            setConfirmed(confirmed);
            
            this.handleRedirect(response.data);
          })
          // eslint-disable-next-line func-names
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(e => {
        console.log(e);
        toast.error(() => (
          <div>
            <FontAwesomeIcon icon="exclamation-triangle" />Error while
            registering user.
          </div>
        ));
      });
  }

  handleChange(e) {
    let _state = {};
    _state[e.target.name] = e.target.value;
    this.setState(_state);
  }

  handleRedirect = (data) => {
    const { dashboard } = data;
    if (!dashboard) {
      setContactDetails(data);
      this.props.history.push(TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS);
      return;
    } else {
      const { id, business, role, dashboard } = data;
      setUserData(data);
      setUserId(id);
      setBusinessId(business.id);
      setRole(role);
      setDashboardMetricObject(dashboard);

      const pushUrl = insertIdtoUrl(
        ROUTES.BUSINESS_DASHBOARD_INDEX,
        business.id
      );
      this.props.history.push(pushUrl);
    }
  }

  render() {
    const { businessId } = this.state;
    return (
      <div className="d-flex justify-content-center">
        <div className="col-md-4 offset-md-4 m-5 pb-3 border">
          <div
            className="row d-flex justify-content-center pt-3"
            style={{ backgroundColor: "#29508b" }}
          >
            <div className="col-md-12 d-flex justify-content-center">
              <img src={logo} className="logo" />
            </div>
            <p className="text-center clearfix text-white mt-3">
              You are invited to manage activities at{" "}
              <i>{this.state.businessName}</i>.<br />
              Please fill in the form below to participate.
            </p>
          </div>
          <div className="mt-3">
            <BusinessUserForm
              user={this.state}
              handleChange={this.handleChange}
              create={true}
              businessId={businessId}
              addUser={this.addUser}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AddNewBusinessUser;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/business-users/AddNewBusinessUser.js